import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { Field, reduxForm, change } from "redux-form";
import { Row, Col, Form, FormGroup, Input } from "reactstrap";
import classNames from "classnames";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index.es.js";  // This import only works for FA v6.7.2 + react-fontawesome@0.1.18. 
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";
import moment from "moment";

import RecipeRatingStar from "../components/RecipeRatingStar";
import {
  InputText,
  Dropdown,
  Loading,
  Valert,
  Vmodal,
  DateTimePicker,
  Validations,
  Highlighted,
} from "../components";
import {
  isLoadedFromMobile,
  getCurrentOrientation,
} from "../services/MobileService";
import { Orientations } from "./PageConstants";
import recipeManagementActions from "../actions/recipeManagementActions";
import {
  REACT_STYLE_BUTTON_SIZE_DESKTOP,
  REACT_STYLE_BUTTON_SIZE_MOBILE,
} from "./Constants";
import "./styles/recipeManagement.css";
import "./styles/recipeManagementModern.css";
import {
  IS_UNSAVED,
  ACTIVITY_UNITS,
  FOOD_UNITS,
  SYMPTOM_UNITS_NEW,
  DRUG_UNITS,
  PCP_UNITS,
  SUP_UNITS,
  LOC_UNITS,
} from "../actions/constant";
import { loginRequired } from "../services/UserService";
import NoDataAlert from "../components/noDataAlert";
class RecipeManagementForm extends Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    this.state = {
      mPlanDate: moment(),
      shareEmail: "",
      searchTerm: "",
    };
    this.rankOptions = [
      {
        value: "created",
        label: t("recipe_management.SORT_DROPDOWN_LABEL_DATE"),
      },
      {
        value: "recipe",
        label: t("recipe_management.SORT_DROPDOWN_LABEL_NAME"),
      },
      { value: "rank", label: t("recipe_management.SORT_DROPDOWN_LABEL_RANK") },
      {
        value: "rating",
        label: t("recipe_management.SORT_DROPDOWN_LABEL_RATE"),
      },
    ];
    this.sortChange = this.sortChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onCategoryChange = this.onCategoryChange.bind(this);
  }

  onCategoryChange(e) {
    // 1) Clear the local search box
    if (this.state.searchTerm) this.setState({ searchTerm: "" });
    // 2) Clear Redux keyword and sort
    const sortBy = "rank";
    this.props.ingredientFilter("", sortBy, "search");
    // 3) Proceed with the original category change flow
    this.props.categorySelected(e);
  }

  sortChange(e) {
    this.props.ingredientFilter(
      this.props.recipeManagementForm.search,
      e.target.value,
      e.target.name
    );
    this.props.myRef.current.scrollTo({ top: 0, behavior: "smooth" });
  }
  onSearch(e) {
    this.setState({ searchTerm: e.target.value });
    this.props.ingredientFilter(
      e.target.value,
      this.props.recipeManagementForm.sortBy,
      "search"
    );
  }
  onDateChangeSearch(result) {
    this.setState({ mPlanDate: result.target.value });
    this.props.onChangeMealPlanner(result);
  }
  render() {
    const { t, initcat, dlModal, mPlanModal, selectedItems } = this.props;
    return (
      <Form
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <Vmodal
          displayStatus={this.props.saveSuccess ? false : dlModal}
          data={
            // marginLeft: 15, marginRight: 15, paddingTop: 20
            <div style={{ width: 350, paddingTop: 25 }}>

              {/* Title */}
              <h4 style={{ fontWeight: 700, margin: "0 0 13px 0" }}>
                {this.props.t("recipe_management.ADD_TO_MEAL_PLAN_TITLE")}
              </h4>

              {/* Body text */}
              <p style={{ margin: "0 0 16px 0", lineHeight: 1.4 }}>
                {this.props.t("recipe_management.ADD_TO_MEAL_PLAN_TEXT")}
              </p>

              <Form>
                <FormGroup row>
                  <Col xs="6">
                    <DateTimePicker
                      name="mPlanDate"
                      placeholder={this.props.t("meal_planner.DATE_TEXT")}
                      value={mPlanModal.mPlanDate}
                      onChange={(val) => {
                        var result = { target: {} };
                        result.target.value = moment(val).startOf("day");
                        result.target.name = "mPlanDate";
                        //this.setState({ mPlanDate: result.target.value });
                        if (
                          !mPlanModal.mPlanDate ||
                          moment(result.target.value).startOf("day").unix() !=
                          moment(mPlanModal.mPlanDate).startOf("day").unix()
                        ) {
                          //this.props.onChangeMealPlanner(result);
                          this.onDateChangeSearch(result);
                        }
                      }}
                      dateFormat="DD MMM YYYY"
                      timeDisable="true"
                      //disableFutureDates={true}
                      disabled={false}
                    />
                  </Col>
                  <Col xs="6">
                    <Field
                      name="mPlanmeal"
                      component={Dropdown}
                      disabled={false}
                      options={[
                        {
                          value: "breakfast",
                          label: this.props.t(
                            "general.BREAKFAST_MEAL_CATEGORY"
                          ),
                        },
                        {
                          value: "lunch",
                          label: this.props.t("general.LUNCH_MEAL_CATEGORY"),
                        },
                        {
                          value: "dinner",
                          label: this.props.t("general.DINNER_MEAL_CATEGORY"),
                        },
                        {
                          value: "supper",
                          label: this.props.t("general.SUPPER_MEAL_CATEGORY"),
                        },
                        {
                          value: "snack1",
                          label: this.props.t("general.SNACK1_MEAL_CATEGORY"),
                        },
                        {
                          value: "snack2",
                          label: this.props.t("general.SNACK2_MEAL_CATEGORY"),
                        },
                        {
                          value: "snack3",
                          label: this.props.t("general.SNACK3_MEAL_CATEGORY"),
                        },
                      ]}
                      placeholder={this.props.t(
                        "meal_planner.SELECT_MEAL_TEXT"
                      )}
                      onChange={(e) => this.props.onChangeMealPlanner(e)}
                    />
                  </Col>
                </FormGroup>
              </Form>

              {/* <button
                style={{ float: "right", padding: "8px 25px", marginTop: 10 }}
                type="button"
                className="btn btn-primary"
                disabled={
                  mPlanModal &&
                    mPlanModal.mPlanmeal &&
                    mPlanModal.mPlanmeal != "null"
                    ? false
                    : true
                }
                onClick={(e) => {
                  e.stopPropagation();
                  this.props.onSubmitMealPlanner(
                    mPlanModal,
                    selectedItems,
                    this.props.history
                  );
                  localStorage.removeItem("unsavedAlertData");
                  IS_UNSAVED("no");
                }}
              //onClick={this.props.onSubmitMealPlanner(mPlanModal)}
              >
                {this.props.t("general.ADD_BUTTON_TEXT")}
              </button> */}


             <div className="ButtonsContainer" style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.props.onSubmitMealPlanner(
                      mPlanModal,
                      selectedItems,
                      this.props.history
                    );
                    localStorage.removeItem("unsavedAlertData");
                    IS_UNSAVED("no");
                  }}
                  disabled={
                    mPlanModal &&
                      mPlanModal.mPlanmeal &&
                      mPlanModal.mPlanmeal != "null"
                      ? false
                      : true
                  }
                >
                  {this.props.t("general.ADD_BUTTON_TEXT")}
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    this.props.closeModal();
                  }}
                >
                  {this.props.t("general.CANCEL")}
                </button>
              </div>
            </div>
          }
          closeFunc={() => {
            this.props.closeModal();
          }}
        />
        <FormGroup row>
          <Col>
            <Field
              name="category"
              component={Dropdown}
              options={t("KIT_CAT", { returnObjects: true })}
              onChange={this.onCategoryChange}
              val={initcat}
            />
          </Col>
          <Col>
            <Field
              name="sortBy"
              component={Dropdown}
              options={this.rankOptions}
              className="sortBy"
              placeholder={t("recipe_management.SORT_DROPDOWN_PLACEHOLDER")}
              onChange={this.sortChange}
            />
          </Col>
          <Col>
            <div
              className="inputWithIcon"
              style={{
                width: "100%",
                position: "relative",
              }}
            >
              <Input
                type="search"
                placeholder={t("forum.SEARCH_KEYWORD_LABEL")}
                onChange={this.onSearch}
                name="search"
                autoComplete="off"
                value={this.state.searchTerm || ""}
              />
              {/* <i
                className="fa fa-search"
                style={{
                  cursor: "default",
                  fontSize: "1rem",
                  marginRight: 9,
                  marginTop: 3,
                }}
              /> */}
              <FontAwesomeIcon
                className="fa fa-search"
                icon={faMagnifyingGlass}
                style={{
                  cursor: "default",
                  fontSize: "1rem",
                  marginRight: 9,
                  marginTop: 3,
                }}
              />
            </div>
          </Col>






        </FormGroup>
      </Form>
    );
  }
}

RecipeManagementForm = reduxForm({
  form: "formRecipeManagement",
  // onChange: (values, dispatch, props, previousValues) => {
  //   props.submit();
  // },
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(RecipeManagementForm);

RecipeManagementForm = connect((state) => ({
  initialValues: state.recipeManagement.recipeManagementForm,
}))(RecipeManagementForm);

class ShareForm extends Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    this.state = {
      shareEmail: "",
      count: 0,
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.shareSuccess == false && this.props.shareSuccess === true) {
      this.setState({ shareEmail: "" });
      this.props.dispatch(change("formRecipeManagementShare", "email", ""));
    }
  }
  render() {
    return (
      <div>
        <Vmodal
          displayStatus={this.props.shareModal}
          data={
            // marginLeft: 15, marginRight: 15, paddingTop: 20
            <div style={{ width: 350, paddingTop: 25 }}>

              {/* Title */}
              <h4 style={{ fontWeight: 700, margin: "0 0 13px 0" }}>
                {this.props.t("recipe_management.SHARE_RECIPE_PROMPT_TITLE")}
              </h4>

              {/* Body text */}
              <p style={{ margin: "0 0 15px 0", lineHeight: 1.4 }}>
                {this.props.t("recipe_management.SHARE_RECIPE_PROMPT_TEXT")}
              </p>

              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <FormGroup row>
                  <Col xs="12">
                    <InputText
                      type="text"
                      placeholder={this.props.t(
                        "recipe_management.RECIPIENT_EMAIL_TEXT"
                      )}
                      invalid={Validations.email(this.state.shareEmail)}
                      input={{
                        onChange: (e) =>
                          this.setState({ shareEmail: e.target.value }),
                        name: "email",
                        value: this.state.shareEmail,
                      }}
                      meta={{
                        touched: true,
                        error: Validations.email(this.state.shareEmail),
                      }}
                      style={{
                        borderColor: "#ced4da",
                        boxShadow: "none",
                        backgroundImage: "none",
                      }}
                    />
                  </Col>
                </FormGroup>
              </Form>

              {/* <button
                style={{ float: "right", padding: "8px 25px", marginTop: 10 }}
                type="button"
                className="btn btn-primary"
                disabled={
                  Validations.email(this.state.shareEmail)
                    ? true
                    : this.state.shareEmail
                      ? false
                      : true
                }
                onClick={(e) => {
                  e.stopPropagation();
                  // this.setState({ shareEmail: "" });
                  // this.props.dispatch(
                  //   change("formRecipeManagementShare", "email", "")
                  // );
                  this.props.shareModalState();
                  this.props.shareClicked(this.state.shareEmail);
                }}
              >
                {this.props.t("recipe_management.SHARE_BUTTON_TEXT")}
              </button> */}


              <div className="ButtonsContainer" style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.props.shareModalState();
                    this.props.shareClicked(this.state.shareEmail);
                  }}
                  disabled={
                    Validations.email(this.state.shareEmail)
                      ? true
                      : this.state.shareEmail
                        ? false
                        : true
                  }
                >
                  {this.props.t("recipe_management.SHARE_BUTTON_TEXT")}
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    this.props.dispatch(
                      change("formRecipeManagementShare", "email", "")
                    );
                    this.setState({ shareEmail: "" });
                    this.props.shareModalState();
                  }}
                >
                  {this.props.t("general.CANCEL")}
                </button>
              </div>

            </div>
          }
          closeFunc={() => {
            this.props.dispatch(
              change("formRecipeManagementShare", "email", "")
            );
            this.setState({ shareEmail: "" });
            this.props.shareModalState();
          }}
        />
      </div>
    );
  }
}
ShareForm = reduxForm({
  form: "formRecipeManagementShare",
  // enableReinitialize: true,
  // keepDirtyOnReinitialize: true,
})(ShareForm);

// ShareForm = connect((state) => ({
//   initialValues: state.recipeManagement.ShareForm,
// }))(ShareForm);
class RecipeManagement extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.recipeEndRef = React.createRef();
    this.ingredientTogglerClick.bind(this);
    this.state = {
      isDeleting: false,
      isEditing: false,
      initcat: "999",
      dlModal: false,
      mPlanDate: moment(),
      shareModal: false,
      // shareSuccess: false,
      invalidInput: false,
      recipeInUse: false,
      updateRank: false,
    };

    //this.deleteClicked = this.deleteClicked.bind(this);
    this.editClicked = this.editClicked.bind(this);
    this.rankClicked = this.rankClicked.bind(this);
    this.changeRank = this.changeRank.bind(this);
    this.categorySelected = this.categorySelected.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.NO_OP = this.NO_OP.bind(this);
  }

  scrollToBottom() {
    const container = this.myRef.current;
    if (container) {
      container.style.scrollBehavior = "smooth";
      container.scrollTop = container.scrollHeight;
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const defaultCat = localStorage.getItem("defaultRecipeManagmentCat");
    if (defaultCat && prevProps.recipes.length > 1) {
      this.scrollToBottom();
      localStorage.removeItem("defaultRecipeManagmentCat");
    }

    const prevLen = (prevProps.selectedItems || []).length;
    this.updateUnsavedShareFlag(prevLen); // react to selection changes
  }

  async componentDidMount() {
    this.updateUnsavedShareFlag(); // initialize once on mount
    loginRequired();
    const defaultCat = await localStorage.getItem("defaultRecipeManagmentCat");
    let sharedRecipeCat = await localStorage.getItem("sharedRecipeCat");
    if (defaultCat) {
      this.setState({ initcat: defaultCat });
      this.props.initialization(defaultCat);
    } else if (sharedRecipeCat && sharedRecipeCat !== null) {
      sharedRecipeCat =
        sharedRecipeCat === "02"
          ? "999"
          : sharedRecipeCat === "10"
            ? "02"
            : sharedRecipeCat;
      this.setState({ initcat: sharedRecipeCat });
      localStorage.removeItem("sharedRecipeCat");
      await this.props.initialization(this.state.initcat);
      this.myRef.current.scrollTo({ top: 999999, behavior: "smooth" });
    } else {
      this.props.initialization(this.state.initcat);
    }
    localStorage.removeItem("recipeCat");
  }

  componentWillUnmount() {
    // Safety: clear if we’re the one that set it
    const usd = JSON.parse(localStorage.getItem("unsavedAlertData") || "null");
    if (usd && usd.page === "recipe_management") {
      localStorage.removeItem("unsavedAlertData");
      IS_UNSAVED("no");
    }
  }

  // Mark/clear unsaved state when Share becomes enabled/disabled
  applyUnsavedShare = (enabled) => {
    const key = "unsavedAlertData";
    const current = JSON.parse(localStorage.getItem(key) || "null");

    if (enabled) {
      localStorage.setItem(
        key,
        JSON.stringify({
          page: "recipe_management",
          title: this.props.t("recipe_management.INCOMPLETE_ACTION_ON_SELECTED_ITEM_TITLE"),
          text: this.props.t("recipe_management.INCOMPLETE_ACTION_ON_SELECTED_ITEM_TEXT"),
        })
      );
      IS_UNSAVED("yes");
    } else {
      // Only clear if we’re the page that set it
      if (current && current.page === "recipe_management") {
        localStorage.removeItem(key);
        IS_UNSAVED("no");
      }
    }
  };

  // Compare current vs previous selection count and toggle unsaved status
  updateUnsavedShareFlag = (prevLen = null) => {
    const nowLen = (this.props.selectedItems || []).length;
    if (prevLen === null || nowLen !== prevLen) {
      this.applyUnsavedShare(nowLen > 0);
    }
  };

  handleCreateNewClick = () => {
    const unsaved = localStorage.getItem("unsavedAlertData");
    if (unsaved) {
      this.unsavedData.changeStatus();
    } else {
      // Nothing unsaved → go
      window.location.href = "/recipe";
    }
  };

  ingredientTogglerClick(id, isExpand, isDone) {
    this.props.ingredientToggle(id, isExpand, isDone);
  }

  recipeSelectToggle(id) {
    this.props.recipeSelectToggle(id);
    this.setState({ shareSuccess: false });
  }

  componentWillReceiveProps(nextProps) {
    if (typeof nextProps.recipes !== "undefined") {
      let selected = 0;
      _.forEach(nextProps.recipes, (recipe) => {
        selected += recipe.isSelected ? 1 : 0;
      });

      this.setState({ isDeleting: selected > 0 });
      this.setState({ isEditing: selected === 1 });
    }
  }
  categorySelected(e) {
    this.setState({ initcat: e.target.value });
    this.props.categorySelected(e);
    this.myRef.current.scrollTo({ top: 0, behavior: "smooth" });
  }
  closeModal() {
    this.setState({ dlModal: false });
  }
  handleSubmit(values) {
    this.props.ingredientFilter(values.search, values.sortBy);
  }

  editClicked(e) {
    const unsaved = localStorage.getItem("unsavedAlertData");
    if (unsaved) {
      // remember that this prompt came from an edit intent
      this.pendingAction = { type: "edit", id: e, cat: this.state.initcat };
      this.unsavedData.changeStatus();
    } else {
      let cat = this.state.initcat;
      let id = 0;
      id = e;
      localStorage.setItem("recipeCat", cat);

      localStorage.setItem(
        "recipePageTitle",
        this.props.t("recipe.EDIT_REGIMEN_PAGE_TITLE")
      );
      (window.location.href = "/recipe/?id=" + id), { cat: cat };

      this.setState({ shareSuccess: false });
    }
  }
  shareClicked(email) {
    let cat = this.state.initcat;
    let shareIds = [];
    _.forEach(this.props.selectedItems, (recipe) => {
      shareIds.push(recipe.id);
    });
    this.props.share(cat, shareIds, email);
  }

  NO_OP(e) { }

  rankClicked(id, rank) {
    if (rank < 1 || rank > this.props.recipes.length) {
      this.setState({ invalidInput: true, updateRank: false });
    } else {
      this.setState({ invalidInput: false, updateRank: false });
    }
    this.rankStack = { id: id, rank: rank };
    this.setState({ rankValue: rank });
    this.RankValert.changeStatus();
  }
  changeRank() {
    var rankUpdate = this.RankValert.getInputValue();
    const { id, rank } = this.rankStack;
    if (this.state.updateRank) {
      this.props.updateRank(id, rankUpdate, rank, this.state.initcat);
      this.props.updateRank_2(id, rankUpdate, rank, this.state.initcat);
    }
  }
  shareModalState() {
    this.setState({ shareModal: !this.state.shareModal });
  }

  async handleRecipeDelete(id, recipe) {
    await this.props.recipeSelectedForDelete(id);
    if (this.props.checkedRecipes && this.props.checkedRecipes !== null) {
      if (
        (this.props.checkedRecipes.recipes &&
          this.props.checkedRecipes.recipes.length > 0) ||
        (this.props.checkedRecipes.meal_sets &&
          this.props.checkedRecipes.meal_sets.length > 0)
      ) {
        this.setState({
          recipeInUse: true,
        });
      } else if (
        this.props.checkedRecipes.meal_plans &&
        this.props.checkedRecipes.meal_plans.length > 0
      ) {
        this.recipeUsedInMealplan.changeStatus();
      } else {
        this.deleteValert.changeStatus();
      }
    }
    this.recipeId = id;
  }
  render() {
    const { isLoading, t, recipes, userLang, recipeManagementForm } =
      this.props;
    let rankValertSentence =
      userLang === "zh-CN" ? (
        <span>
          您的列表上有 {this.props.recipesAll.length} 种食谱或程序。
          请为此食谱或程序输入一个介于
          <span
            style={{
              color:
                this.state.rankValue < 1 ||
                  this.state.rankValue > this.props.recipesAll.length
                  ? "#dc3545"
                  : "inherit",
            }}
          >
            {" "}
            1-{this.props.recipesAll.length}{" "}
          </span>
          之间的数字。
        </span>
      ) : userLang === "zh-TW" ? (
        <span>
          您的列表上有 {this.props.recipesAll.length} 種食譜或程序。
          請為此食譜或程序輸入一個介於
          <span
            style={{
              color:
                this.state.rankValue < 1 ||
                  this.state.rankValue > this.props.recipesAll.length
                  ? "#dc3545"
                  : "inherit",
            }}
          >
            {" "}
            1-{this.props.recipesAll.length}{" "}
          </span>
          之間的數字。
        </span>
      ) : (
        <span>
          You have {this.props.recipesAll.length} recipes/ regimens on the list.
          Please enter a number between
          <span
            style={{
              color:
                this.state.rankValue < 1 ||
                  this.state.rankValue > this.props.recipesAll.length
                  ? "#dc3545"
                  : "inherit",
            }}
          >
            {" "}
            1-{this.props.recipesAll.length}{" "}
          </span>
          for this recipe/ regimen.
        </span>
      );
    const deleteClass = classNames("btn", "btn-primary", {
      disabled: !this.state.isDeleting,
    });
    const editClass = classNames("btn", "btn-primary", {
      disabled: !this.state.isEditing,
    });
    var _pageFitter, _btnFontSize;
    if (
      isLoadedFromMobile() ||
      getCurrentOrientation() === Orientations.PORTRAIT
    ) {
      _pageFitter = "page-fitter-mobile";
      _btnFontSize = REACT_STYLE_BUTTON_SIZE_MOBILE;
    } else {
      _pageFitter = "page-fitter";
      _btnFontSize = REACT_STYLE_BUTTON_SIZE_DESKTOP;
    }
    //page-wrapper-recipe-management
    const rankColWidth = 40;
    const rankColShift = -7;
    const nameStartOffset = rankColWidth + rankColShift;
    const expandIconOffset = 10;

    return (
      <div>
        <div style={{ minHeight: "auto" }} className="vPage recipe-mgmt-modern">
          <Loading isLoading={isLoading} />
          <Vmodal
            displayStatus={this.state.recipeInUse}
            data={
              <div>
                <h5>{t("recipe_management.RECIPE_IN_USE_TITLE")}</h5>
                <p>{t("recipe_management.RECIPE_IN_USE_TEXT_1")}</p>
                <ul
                  style={{
                    listStyleType: "disc",
                    marginLeft: "20px",
                    marginBottom: "15px",
                    marginTop: "0px",
                  }}
                >
                  {this.props.checkedRecipes &&
                    this.props.checkedRecipes.recipes &&
                    this.props.checkedRecipes.recipes.map((item) => {
                      return <li>{item.recipe_full}</li>;
                    })}
                  {this.props.checkedRecipes &&
                    this.props.checkedRecipes.meal_sets &&
                    this.props.checkedRecipes.meal_sets.map((item) => {
                      return <li>{item.recipe_full}</li>;
                    })}
                </ul>
                <p>{t("recipe_management.RECIPE_IN_USE_TEXT_2")}</p>
                <div className="d-flex justify-content-end margin-top-10">
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ padding: "7px 25px" }}
                    onClick={() => {
                      this.setState({
                        recipeInUse: false,
                      });
                    }}
                  >
                    {t("general.OK_PROMPT_TEXT")}
                  </button>
                </div>
              </div>
            }
            closeFunc={() => {
              this.setState({ recipeInUse: false });
            }}
          />
          <Valert
            display={false}
            title={t("general.DELETE_CONFIRMATION_TITLE")}
            question={
              this.state.initcat === "999"
                ? t("recipe_management.RECIPE_CONFIRMATION_TEXT")
                : t("recipe_management.REGIMEN_CONFIRMATION_TEXT")
            }
            onRef={(ref) => (this.deleteValert = ref)}
            positiveText={t("general.POSITIVE_PROMPT_TEXT")}
            negativeText={t("general.CANCEL")}
            positiveAction={() => {
              this.props.deleteRecipes(this.recipeId, this.state.initcat);
            }}
          />
          <Valert
            display={false}
            title={t("recipe_management.INCOMPLETE_ACTION_ON_SELECTED_ITEM_TITLE")}
            question={t("recipe_management.INCOMPLETE_ACTION_ON_SELECTED_ITEM_TEXT")}
            onRef={(ref) => (this.unsavedData = ref)}
            positiveText={t("general.POSITIVE_PROMPT_TEXT")}
            negativeText={t("general.CANCEL")}
            positiveAction={() => {
              // clear the unsaved flag first
              IS_UNSAVED("no");
              localStorage.removeItem("unsavedAlertData");

              const act = this.pendingAction;
              this.pendingAction = null;

              if (act && act.type === "edit" && act.id) {
                const cat = act.cat || this.state.initcat;
                const id = act.id;
                localStorage.setItem("recipeCat", cat);
                localStorage.setItem(
                  "recipePageTitle",
                  this.props.t("recipe.EDIT_REGIMEN_PAGE_TITLE")
                );
                (window.location.href = "/recipe/?id=" + id), { cat: cat };
                this.setState({ shareSuccess: false });
              } else {
                // default fallback: go to create/new page
                window.location.href = "/recipe";
              }
            }}
          />

          <Valert
            display={false}
            title={t("recipe_management.RECIPE_USED_IN_MEALPLAN_TITLE")}
            question={t("recipe_management.RECIPE_USED_IN_MEALPLAN_TEXT")}
            onRef={(ref) => (this.recipeUsedInMealplan = ref)}
            positiveText={t("general.POSITIVE_PROMPT_TEXT")}
            negativeText={t("general.CANCEL")}
            positiveAction={() => {
              this.props.deleteRecipes(this.recipeId, this.state.initcat);
            }}
          />
          {/* <Valert
            display={false}
            title={t("general.DELETE_CONFIRMATION_TITLE")}
            question={t("recipe.DELETE_PROMPT_TEXT")}
            onRef={(ref) => (this.deleteValert = ref)}
            positiveAction={() => {
              // let ids = [];
              // _.forEach(this.props.recipes, (recipe) => {
              //   if (recipe.isSelected) {
              //     ids.push(recipe._id);
              //     this.props.deleteRecipes(recipe._id, this.state.initcat);
              //   }
              // });
              this.props.deleteRecipes(this.recipeId, this.state.initcat);
            }}
            positiveText={t("general.POSITIVE_PROMPT_TEXT")}
            negativeText={t("general.CANCEL")}
          /> */}
          <Valert
            display={this.props.shareSuccess}
            title={t("general.SHARED_SUCCESSFULLY_PROMPT_TITLE")}
            question={t("recipe_management.SHARE_RECIPE_PROMPT_MESSAGE")}
            onRef={(ref) => (this.shareSuccess = ref)}
            readOnly={true}
            positiveText={t("general.OK_PROMPT_TEXT")}
            positiveAction={() => this.props.shareSuccessStatus()}
          />
          <Valert
            display={this.props.shareError}
            title={t("forgot.UNREGISTERED_EMAIL_TITLE")}
            question={this.props.shareErrorMsg}
            onRef={(ref) => (this.shareSuccess = ref)}
            readOnly={true}
            positiveText={t("general.OK_PROMPT_TEXT")}
            positiveAction={() => this.shareModalState()}
          />
          <Vmodal
            displayStatus={this.props.saveSuccess}
            data={
              <div className="mb-4">
                <h4>{this.props.t("general.SAVE_SUCCESSFULLY_TITLE")}</h4>
                <p>
                  {this.props.t("meal_planner.SAVE_MEALPLAN_SUCCESSFULLY_TEXT")}
                </p>
              </div>
            }
            closeFunc={() => {
              this.props.clearManageRegimen();
              localStorage.removeItem("unsavedAlertData");
              const redirectTime = moment(this.props.mPlanModal.mPlanDate)
                .startOf("isoWeek")
                .unix();
              window.location.href = `/mealplansummary/${redirectTime}`;
              // window.location.reload();
            }}
            timedClose={2000}
          />

          <Valert
            display={false}
            title={t("recipe_management.ENTER_RANK_TITLE")}
            question={rankValertSentence}
            onRef={(ref) => (this.RankValert = ref)}
            positiveText={t("general.OK_PROMPT_TEXT")}
            negativeText={t("general.CANCEL")}
            inputField={true}
            positiveAction={this.changeRank}
            inputValue={this.state.rankValue}
            invalid={
              this.state.rankValue > this.props.recipesAll.length &&
                this.state.rankValue < 1
                ? true
                : false
            }
            inputType={"number"}
            max={this.props.recipesAll ? this.props.recipesAll.length : 1}
            invalidText={false}
            crossIcon="true"
            onChangeInput={(e) => {
              this.setState({ rankValue: e.target.value, updateRank: true });
            }}
          />
          <ShareForm
            selectedItems={this.props.selectedItems}
            shareModalState={this.shareModalState.bind(this)}
            shareModal={this.state.shareModal}
            shareClicked={this.shareClicked.bind(this)}
            shareChange={this.props.shareChange}
            ingredientFilter={this.props.ingredientFilter}
            t={this.props.t}
            shareSuccess={this.props.shareSuccess}
          />

          <RecipeManagementForm
            onSubmit={this.handleSubmit.bind(this)}
            categorySelected={this.categorySelected.bind(this)}
            t={t}
            initcat={this.state.initcat}
            myRef={this.myRef}
            recipeEndRef={this.recipeEndRef}
            dlModal={this.state.dlModal}
            closeModal={this.closeModal.bind(this)}
            mPlanModal={this.props.mPlanModal}
            saveSuccess={this.props.saveSuccess}
            onChangeMealPlanner={this.props.onChangeMealPlanner}
            onSubmitMealPlanner={this.props.onSubmitMealPlanner}
            history={this.props.history}
            selectedItems={this.props.selectedItems}
            shareModalState={this.shareModalState.bind(this)}
            shareModal={this.state.shareModal}
            shareClicked={this.shareClicked.bind(this)}
            shareChange={this.props.shareChange}
            ingredientFilter={this.props.ingredientFilter}
            recipeManagementForm={this.props.recipeManagementForm}
          />
          <div ref={this.myRef} className="recipeList grayList">
            {recipes && recipes.length > 0
              ? typeof recipes.map !== "undefined" &&
              recipes.map((recipe, i) => {
                const isExpand =
                  typeof recipe.isExpand != "undefined"
                    ? recipe.isExpand
                    : false;
                const ingredientTogglerClass = classNames(
                  "fas",
                  { "fa-chevron-down": !isExpand },
                  { "fa-chevron-up": isExpand }
                );
                const ingredientListClass = classNames("ingredient-list1", {
                  expand: isExpand,
                });

                return (
                  <ul className="recipe-item" key={i}>
                    <li className="wrapper">
                      <Row>
                        <Col xs="9">
                          <div className="recipeItemTopSection">
                            <div className="row recipe-item-title">
                              <div
                                style={{
                                  width: "40px",
                                  textAlign: "right",
                                  marginLeft: "-7px",
                                }}
                              >
                                <Col xs="auto" className="no">
                                  {recipe.rank}
                                  {"."}
                                </Col>
                              </div>
                              <Col>
                                <div
                                  className="name"
                                  style={{
                                    textAlign: "left",
                                    marginLeft: "0px",
                                    wordBreak: "break-all",
                                  }}
                                >
                                  <Highlighted
                                    text={
                                      recipe.name
                                        ? recipe.name
                                        : recipe.recipe
                                    }
                                    highlight={
                                      this.props.recipeManagementForm.search
                                    }
                                  />
                                </div>
                              </Col>
                            </div>
                          </div>

                          <div className="recipe-item-desc">
                            <div className="row recipe-item-rate">
                              <div
                                className="expand"
                                style={{
                                  width: `${nameStartOffset}px`,
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  paddingLeft: `${expandIconOffset}px`,
                                  flexShrink: 0,
                                }}
                              >
                                <a
                                  className="ingredient-toggle"
                                  onClick={this.ingredientTogglerClick.bind(
                                    this,
                                    recipe._id,
                                    isExpand,
                                    recipe.isDone
                                  )}
                                >
                                  <i
                                    style={{ color: "#007bff" }}
                                    className={ingredientTogglerClass}
                                  />
                                </a>
                              </div>
                              <RecipeRatingStar
                                recipeId={recipe._id}
                                cat={this.state.initcat}
                                rating={recipe.rate || 0}
                                updateRating={this.props.updateRating}
                              />
                              <div className="rank-link">
                                <a
                                  onClick={this.rankClicked.bind(
                                    this,
                                    recipe._id,
                                    recipe.rank
                                  )}
                                >
                                  {
                                      /*Rank*/ t(
                                    "recipe_management.SORT_DROPDOWN_LABEL_RANK"
                                  )
                                  }
                                </a>
                              </div>
                            </div>
                            {/* <div>
                              <ul
                                className={ingredientListClass}
                                style={{
                                  width: "30.3rem",
                                }}
                              > */}
                            <div
                              style={{
                                marginLeft: `${nameStartOffset}px`,
                              }}
                            >
                              <ul
                                className={ingredientListClass}
                                style={{
                                  width: "30.3rem",
                                  paddingLeft: 0,
                                  marginLeft: 0,
                                }}
                              >
                                {recipe.ingredients &&
                                  recipe.ingredients.map((ingredient, j) => {
                                    let unitName = "";
                                    let meas = [];
                                    let itemUnit =
                                      ingredient.unitid ||
                                      ingredient.unit[0] ||
                                      "";
                                    if (this.state.initcat == "03") {
                                      meas = ACTIVITY_UNITS();
                                    } else if (this.state.initcat == "01") {
                                      meas = SYMPTOM_UNITS_NEW();
                                    } else if (this.state.initcat == "04") {
                                      meas = PCP_UNITS();
                                    } else if (this.state.initcat == "05") {
                                      meas = DRUG_UNITS();
                                    } else if (
                                      this.state.initcat == "02" ||
                                      this.state.initcat == "999"
                                    ) {
                                      meas = FOOD_UNITS();
                                    } else if (this.state.initcat == "06") {
                                      meas = SUP_UNITS();
                                    } else if (this.state.initcat == "07") {
                                      meas = LOC_UNITS();
                                    }
                                    if (itemUnit) {
                                      for (const mea of meas) {
                                        if (mea._id == itemUnit) {
                                          unitName = mea.displayunit;
                                        }
                                      }
                                    }

                                    return (
                                      <Row key={j}>
                                        <Col xs="2">
                                          {ingredient.value ||
                                            ingredient.size}{" "}
                                          {unitName || ""}
                                        </Col>
                                        <Col xs="10">
                                          {(ingredient.recipe_full &&
                                            ingredient.recipe_full.replace(
                                              /\s/g,
                                              " "
                                            )) ||
                                            (ingredient.fullname &&
                                              ingredient.fullname.replace(
                                                /\s/g,
                                                " "
                                              )) ||
                                            (ingredient.name &&
                                              ingredient.name.replace(
                                                /\s/g,
                                                " "
                                              )) ||
                                            (ingredient.recipe_full &&
                                              ingredient.recipe_full.replace(
                                                /\s/g,
                                                " "
                                              )) ||
                                            ingredient.recipe.replace(
                                              /\s/g,
                                              " "
                                            )}
                                          {ingredient._id.slice(0, 1) ==
                                            "6" && ingredient.upc
                                            ? ` (${ingredient.upc})`
                                            : ""}
                                        </Col>
                                      </Row>
                                    );
                                  })}
                              </ul>
                              {recipe.ingredients && isExpand && (
                                <div
                                  className="manageRecipeItemDes"
                                  style={{
                                    width: "30rem",
                                    textAlign: "justify",
                                    marginLeft: 0,
                                    paddingLeft: 0,
                                  }}
                                >
                                  {recipe.size ? (
                                    <span
                                      style={{
                                        fontSize: "14px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {this.props.t(
                                          "recipe_management.SERVING_SIZE_TEXT"
                                        )}
                                      </span>
                                      {recipe.size + ". "}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                  {recipe.comment ? (
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        textAlign: "justify",
                                        wordBreak: "break-all",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                          wordBreak: "break-all",
                                        }}
                                      >
                                        {this.props.t(
                                          "recipe_management.RECIPE_COMMENT_TEXT"
                                        )}
                                      </span>
                                      {recipe.comment + "."}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </Col>
                        <Col xs="1">
                          <div
                            className="checkmarkContainer"
                            onClick={() => this.editClicked(recipe._id)}
                            style={{
                              marginLeft: "15px",
                              paddingTop: "4px",
                            }}
                          >
                            <i
                              className="fa fa-pencil-alt"
                              style={{
                                // alignSelf: "center",
                                color: "#007bff",
                                cursor: "pointer",
                              }}
                            ></i>
                          </div>
                        </Col>
                        <Col xs="1">
                          <div
                            className="checkmarkContainer"
                            onClick={() => {
                              this.handleRecipeDelete(
                                recipe._id,
                                recipe.recipe
                              );
                            }}
                          >
                            <i
                              className="far fa-trash-alt deleteIcon"
                              style={{
                                // alignSelf: "center",
                                cursor: "pointer",
                                paddingTop: "4px",
                              }}
                            />
                          </div>
                        </Col>
                        <Col xs="1">
                          <div
                            onClick={this.recipeSelectToggle.bind(
                              this,
                              recipe
                            )}
                            className="checkmarkContainer"
                          >
                            <input
                              type="checkbox"
                              checked={recipe.isSelected ? "checked" : ""}
                            />
                            {recipe.isSelected}
                            <span
                              className="checkmark"
                              style={{
                                alignSelf: "baseline",
                                marginTop: "5.5px",
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                    </li>
                  </ul>
                );
              })
              : !isLoading &&
              (recipeManagementForm.search && recipeManagementForm.search.trim() !== "" ? (
                <NoDataAlert
                  text={this.props.t("general.NO_MATCH_FOUND")}
                  pr={0}
                  pl={8}
                  pb={4}
                  pt={4}
                  br={3}
                  bg="transparent"
                />
              ) : this.state.initcat == "999" ? (
                <NoDataAlert
                  text={t("recipe.NO_RECIPE_DATA_TEXT")}
                  bg="transparent"
                />
              ) : (
                <NoDataAlert
                  text={t("recipe.NO_REGIMEN_DATA_TEXT")}
                  bg="transparent"
                />
              ))}
          </div>

          <div className="row ">
            <div className="col">
              <button
                className="btn btn-primary btnWide"
                type="button"
                disabled={this.props.selectedItems.length > 0 ? false : true}
                onClick={(e) => this.setState({ shareModal: true })}
              >
                {this.props.t("recipe_management.SHARE_BUTTON_TEXT")}
              </button>
            </div>
            <div className="col">
              <button
                className="btn btn-primary btnWide"
                type="button"
                disabled={
                  (this.state.initcat === "999" ||
                    this.state.initcat === "02" ||
                    this.state.initcat === "06") &&
                    this.props.selectedItems.length > 0
                    ? false
                    : true
                }
                onClick={(e) => this.setState({ dlModal: true })}
              >
                {t("recipe_management.ADD_TO_MEAL_PLAN_BUTTON")}
              </button>
            </div>
            <div className="col">
              <button
                className="btn btn-primary btnWide"
                type="button"
                onClick={this.handleCreateNewClick}
              >
                {t("recipe_management.CREATE_NEW_BUTTON")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

RecipeManagement = translate("translations")(RecipeManagement);

const mapStateToProps = (state) => ({
  ...state.recipeManagement,
  formRecipeManagement: state.form.formRecipeManagement,
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...recipeManagementActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(RecipeManagement);



// WEBPACK FOOTER //
// ./src/pages/RecipeManagement.js